module.exports = __webpack_public_path__ + "static/media/undo-icon.ff379f60.svg";